import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
    fetch,
    switchDay,
    updateNow,
    toNow,
    refreshTimetable,
    fetchNotifications,
    zoomIn,
    zoomOut
} from '../../actions/events/timetable';
import { showEntry, hideEntry } from '../../actions/events/entries';
import { change } from '../../actions/events/select';
import * as filterSelectors from '../../selectors/events/filter';
import Search from './Search';
import Activity from './Activity';
import ViewFiltersMobile from './ViewFiltersMobile';
import * as selectors from '../../selectors/events/timetable';
import { ENTRY_WIDTH_UNIT } from '../../constants/styling/styles';
import { TIMETABLE_REFRESH_TIME } from '../../constants/settings';
import TimetableView from '../../components/application/timetable/TimetableView';
import ListView from '../../components/application/timetable/ListView';
import EntryDetails from '../../components/application/timetable/entries/EntryDetails';
import TimetableActions from '../../components/application/timetable/TimetableActions';
import {
    toggleTimeView,
    toggleListView,
    setFilter,
    toggleFiltersOpen,
    toggleActivityOpen,
    openViewFilter
} from '../../actions/events/filter';
import { openSearch } from '../../actions/events/search';
import { searchOpenSelector } from '../../selectors/events/search';
import PerformanceFiltersMobile from '../../components/application/timetable/filter/PerformanceFiltersMobile';
import { initializeTalkJsPartner } from '../../services/talk.chat';
import {
    currentUserSelector,
    favoriteArtistsSelector,
    notificationsSeenSelector
} from '../../selectors/authentication';
import { find, get } from 'lodash';
import ChatButton from '../../components/application/events/ChatButton';
import { favOrUnfavArtist } from '../../actions/authentication';

class Timetable extends Component {
    componentDidMount() {
        this.props.fetch(this.props.match.params.id);
        this.props.change(this.props.match.params.id);
        this.intervalID = setInterval(() => {
            this.props.refreshTimetable(this.props.match.params.id);
            this.props.fetchNotifications(this.props.match.params.id);
        }, TIMETABLE_REFRESH_TIME);
    }
    async componentDidUpdate(prevProps) {
        const eventId = get(this.props, 'match.params.id');
        if (prevProps.fetching === true && this.props.fetching === false && eventId && this.props.chat) {
            const chatPopup = await initializeTalkJsPartner(this.props.user, eventId);
            this.setState({ chatPopup });
        }
        if (this.props.showNow && prevProps.fetching === true && this.props.fetching === false) {
            this._goToNow(0);
        }
    }
    componentWillUnmount() {
        clearInterval(this.intervalID);
        this.state && this.state.chatPopup && this.state.chatPopup.destroy();
    }
    _selectDay = day => this.props.switchDay(day);
    _goToNow = (timeout = 100) => {
        this.props.toNow();
        setTimeout(() => window.scroll(this._nowOffset() - window.innerWidth / 2, window.scrollY), timeout);
    };
    _nowOffset = () =>
        selectors.nowOffset(ENTRY_WIDTH_UNIT * this.props.zoom, this.props.minHour, this.props.maxHour, this.props.now);
    _openEntryFromActivity = id => {
        const entry = find(this.props.listViewEntries, lve => lve.id === id);
        if (entry) {
            this.props.showEntry(entry);
        }
    };
    render() {
        return (
            <React.Fragment>
                <TimetableActions
                    toggleFiltersOpen={this.props.toggleFiltersOpen}
                    toggleActivityOpen={this.props.toggleActivityOpen}
                    toggleListView={this.props.toggleListView}
                    toggleTimeView={this.props.toggleTimeView}
                    isLiveView={this.props.isLiveView}
                    isListView={this.props.isListView}
                    selectDay={this._selectDay}
                    selectedDay={this.props.selectedDay}
                    days={this.props.days}
                    stagesFilters={this.props.stagesFilters}
                    artistsFilters={this.props.artistsFilters}
                    liveFilters={this.props.liveFilters}
                    nonLinearFilters={this.props.nonLinearFilters}
                    artistOptions={this.props.listViewArtists}
                    stageOptions={this.props.listViewStages}
                    setFilter={this.props.setFilter}
                    filtersOpen={this.props.filtersOpen}
                    activityOpen={this.props.activityOpen}
                    hasFilter={this.props.hasFilter}
                    openSearch={this.props.openSearch}
                    isSearchOpen={this.props.searchOpen}
                    openViewOptions={this.props.openViewFilter}
                    isViewFilterOpen={this.props.isViewFilterOpen}
                    zoomIn={this.props.zoomIn}
                    zoomOut={this.props.zoomOut}
                    zoom={this.props.zoom}
                    showDot={this.props.showDot}
                />
                {this.props.isListView ? (
                    <ListView
                        noSelect={true}
                        stagesFilters={this.props.stagesFilters}
                        artistsFilters={this.props.artistsFilters}
                        liveFilters={this.props.liveFilters}
                        nonLinearFilters={this.props.nonLinearFilters}
                        sortBy={this.props.performancesSortBy}
                        order={this.props.performancesOrder}
                        setFilter={this.props.setFilter}
                        entries={this.props.listViewEntries}
                        showEntry={this.props.showEntry}
                    />
                ) : (
                    <TimetableView
                        favOrUnfavArtist={this.props.favOrUnfavArtist}
                        favoriteArtists={this.props.favoriteArtists}
                        filtersOpen={this.props.filtersOpen}
                        artistsFilters={this.props.artistsFilters}
                        liveFilters={this.props.liveFilters}
                        nonLinearFilters={this.props.nonLinearFilters}
                        maxHour={this.props.maxHour}
                        onScroll={this._onScroll}
                        selectedPartner={this.props.selectedPartner}
                        updateNow={this.props.updateNow}
                        showNow={this.props.showNow}
                        nowOffset={this._nowOffset}
                        goToNow={this._goToNow}
                        isLiveView={this.props.isLiveView}
                        showEntry={this.props.showEntry}
                        minHour={this.props.minHour}
                        hourIntervals={this.props.hourIntervals}
                        stages={this.props.stages}
                        fetching={this.props.fetching}
                        selectedDay={this.props.selectedDay}
                        scroll={this.props.scroll}
                        zoom={this.props.zoom}
                    />
                )}
                <Search />
                <ViewFiltersMobile />
                <ViewFiltersMobile />
                {window.innerWidth < 1081 && (
                    <PerformanceFiltersMobile
                        stagesFilters={this.props.stagesFilters}
                        artistsFilters={this.props.artistsFilters}
                        liveFilters={this.props.liveFilters}
                        nonLinearFilters={this.props.nonLinearFilters}
                        artistOptions={this.props.listViewArtists}
                        stageOptions={this.props.listViewStages}
                        setFilter={this.props.setFilter}
                        close={this.props.toggleFiltersOpen}
                        isOpen={this.props.filtersOpen}
                    />
                )}
                <EntryDetails
                    open={!!this.props.entry}
                    entry={this.props.entry}
                    contact={this.props.contact}
                    onClose={this.props.hideEntry}
                    selectedPartner={this.props.selectedPartner}
                />
                <Activity
                    seenAt={this.props.notificationsSeenAt}
                    openEntryFromActivity={this._openEntryFromActivity}
                    selectedPartner={this.props.selectedPartner}
                    eventId={get(this.props, 'match.params.id')}
                />
                <ChatButton popup={this.state && this.state.chatPopup} />
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    const hours = selectors.hoursSelector(state);
    return {
        chat: selectors.chatEnabledSelector(state),
        user: currentUserSelector(state),
        isListView: filterSelectors.listViewSelector(state),
        isLiveView: filterSelectors.liveViewSelector(state),
        stages: selectors.stagesSelector(state),
        listViewEntries: selectors.listViewEntriesSelector(state),
        selectedDay: selectors.selectedDaySelector(state),
        days: selectors.daysSelector(state),
        now: selectors.nowSelector(state),
        showNow: selectors.showNow(state),
        hourIntervals: hours.intervals,
        minHour: hours.min,
        maxHour: hours.max,
        favoriteArtists: favoriteArtistsSelector(state),
        notificationsSeenAt: notificationsSeenSelector(state),
        performancesOrder: filterSelectors.orderSelector(state),
        performancesSortBy: filterSelectors.sortBySelector(state),
        selectedPartner: filterSelectors.filterSelectedPartnerSelector(state),
        entry: selectors.entrySelector(state),
        contact: selectors.contactSelector(state),
        fetching: selectors.fetchingSelector(state),
        listViewArtists: selectors.listViewArtistsSelector(state),
        listViewStages: selectors.listViewStagesSelector(state),
        stagesFilters: filterSelectors.stagesFilterSelector(state),
        artistsFilters: filterSelectors.artistsFilterSelector(state),
        liveFilters: filterSelectors.liveFilterSelector(state),
        nonLinearFilters: filterSelectors.nonLinearFilterSelector(state),
        showDot: selectors.showDotNotificationsSelector(state),
        filtersOpen: filterSelectors.filtersOpenSelector(state),
        activityOpen: filterSelectors.activityOpenSelector(state),
        searchOpen: searchOpenSelector(state),
        hasFilter: filterSelectors.hasFilterSelector(state),
        isViewFilterOpen: filterSelectors.viewFilterOpenSelector(state),
        zoom: selectors.zoomSelector(state)
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetch,
            showEntry,
            favOrUnfavArtist,
            toggleFiltersOpen,
            toggleActivityOpen,
            refreshTimetable,
            fetchNotifications,
            toggleTimeView,
            toggleListView,
            hideEntry,
            change,
            switchDay,
            setFilter,
            updateNow,
            openSearch,
            openViewFilter,
            zoomOut,
            zoomIn,
            toNow
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(Timetable);



// WEBPACK FOOTER //
// ./src/containers/events/Timetable.js